<template>
<div>
<h6 class="h6">
{{$vuetify.lang.t('$vuetify.cui-all-organizations')}}</h6>
    <p v-if="finalModel.data && finalModel.data.organizationCount==0">{{$vuetify.lang.t('$vuetify.cui-no-orgs-for-name')}}</p>
     <div v-if="finalModel.data && finalModel.data.organizationCount > 0">
      <div class="cui-input-button cui-input-button--alt-bg">
         <input class="cui-input-button__input" type="text" v-model="orgFilterByname"  placeholder="Filter by organization name" />
         <button class="cui-input-button__button" @click="filterTheOrgs()">Search</button>
      </div>
  <div class=".cui-loading__container--organization-list" v-if="spinner">
    <div class="cui-loading--center"><div class="cui-loading"></div></div>
  </div>
       <p v-if="!(this.finalModel.data.organizations.length > 0)">{{$vuetify.lang.t('$vuetify.cui-no-orgs-for-name')}}</p>
    <v-expansion-panels style="margin-top: 50px;margin-bottom: 50px;">
           <v-expansion-panel
          v-for="(org) in organizations"
          :key="org.id"
        >
         <v-expansion-panel-header >{{org.name}}</v-expansion-panel-header>
          <v-expansion-panel-content class="cui-expandable__body">
    <span class="cui-field-val__val">{{org.addresses[0].streets[0]}}</span>
    <span class="cui-field-val__val">{{org.addresses[0].city}}</span>
    <span class="cui-field-val__val">{{org.addresses[0].state}}</span>
    <span class="cui-field-val__val">{{org.addresses[0].postal}}</span><br>
    <span class="cui-field-val__val">{{org.phones[0].number}}</span><br>
    <span class="cui-field-val__val">{{org.url}}</span><br>
        <div class="cui-wizard__controls">
        <button type="button" class="cui-wizard__next" @click="selectOrganization(org)">{{$vuetify.lang.t('$vuetify.cui-select-org')}}</button>
      </div>
           </v-expansion-panel-content>
           </v-expansion-panel>
      </v-expansion-panels>
      </div>
</div>
</template>
<script>
// import Vue from 'vue'
export default {
  data () {
    return {
      spinner: false,
      organizationDetails: {},
      applications: [],
      passwordRules: {},
      orgFilterByname: ''
    }
  },
  props: ['finalModel'],
  validations: {
    form: []
  },
  computed: {
    organizations: function () {
      return this.$store.getters.getOrganizations
    }
  },
  watch: {
    organizations:
    function () {
      return this.$store.getters.getOrganizations
    }
  },
  methods: {
    validate () {
      this.$v.form.$touch()
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },
    filterTheOrgs () {
      this.spinner = true
      this.$API.initiateNonce()
        .then((res) => {
          this.$API.getOrganizationsWithNonce({qs: [['page', 1], ['pageSize', 10], ['status', 'active'], ['name', this.orgFilterByname]]})
            .then(res => {
              this.finalModel.data.organizations = res
              this.organizations = res
              this.$store.dispatch('setOrganizations', res)
              this.spinner = false
            })
            .fail(error => {
              this.spinner = false
              console.log(error)
            })
        })
        .fail(error => {
          console.log(error)
        })
    },
    selectOrganization (org) {
      const results = {
        grants: []
      }
      this.$API.initiateNonce()
        .then(res => {
          results.grants = res
          return this.$API.getPasswordPoliciesNonce({policyId: org.passwordPolicy.id})
        })
        .then(res => {
          results.passwordRules = res.rules
          results.passwordRules.forEach((value, index) => {
            if (value.type === 'length') {
              this.passwordRules.length = value
            }
            if (value.type === 'character_class') {
              this.passwordRules.characterClass = value
            }
            if (value.type === 'disallowed_words') {
              this.passwordRules.disallowedWords = value
            }
            if (value.type === 'lifetime') {
              this.passwordRules.lifetime = value
            }
            if (value.type === 'history') {
              this.passwordRules.history = value
            }
          })
          // this.passwordRules = res.rules
        })
        .then(res => {
          return this.$API.getOrgAppsCountNonce({organizationId: org.id})
        })
        .then(res => {
          results.appCount = res
          this.$API.getOrgAppsNonce({organizationId: org.id, qs: [['page', 1], ['pageSize', 10]]})
            .then(res => {
              results.applications = res
              this.applications = res
              this.validate()
              Promise.resolve(results)
            })
            .fail(err => {
              console.log(err)
            })
        })
        .fail(error => {
          console.log(error)
        })
      this.organizationDetails = org
      this.$emit('on-click', 'value')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/registration/organization.vue